import { render, staticRenderFns } from "./WalletStatementPartnerOwn.vue?vue&type=template&id=39ed7118&scoped=true&"
import script from "./WalletStatementPartnerOwn.vue?vue&type=script&lang=js&"
export * from "./WalletStatementPartnerOwn.vue?vue&type=script&lang=js&"
import style0 from "./WalletStatementPartnerOwn.vue?vue&type=style&index=0&id=39ed7118&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ed7118",
  null
  
)

export default component.exports